import ChicletsContainer from '@next-app/components/shared/PageContent/ChicletsContainer/ChicletsContainer';

const SRPFeaturedCategories = ({ data }: any) => {
  const chicletsContainerData = data?.content?.find(
    (item: any) => item['@type'] === 'PageContent-ChicletsContainer',
  );

  if (chicletsContainerData) {
    chicletsContainerData.chicletType = 'large_rectangle';
    chicletsContainerData.textDecoration = true;
  }

  return <ChicletsContainer contentItem={chicletsContainerData} />;
};
export default SRPFeaturedCategories;
